const API_BASE = import.meta.env.VITE_API_BASE || ''

export async function fetchNearby(lat: number, lon: number, radius_m: number, lang: string, limit: number) {
  const u = new URL(`${API_BASE}/api/pois/nearby`)
  u.searchParams.set('lat', String(lat))
  u.searchParams.set('lon', String(lon))
  u.searchParams.set('radius_m', String(radius_m))
  u.searchParams.set('lang', lang)
  u.searchParams.set('limit', String(limit))
  const r = await fetch(u.toString(), { credentials: 'omit' })
  if (!r.ok) {
    let msg = 'request failed'
    try {
      const data = await r.json()
      msg = data?.error || msg
    } catch {
      msg = `${r.status}`
    }
    throw new Error(msg)
  }
  return await r.json()
}

export async function fetchPOI(id: string, lang: string) {
  const u = new URL(`${API_BASE}/api/poi/${id}`)
  u.searchParams.set('lang', lang)
  const r = await fetch(u.toString())
  const data = await r.json()
  if (!data?.summary && data?.wiki_title) {
    try {
      const langCode = (lang || 'en').split('-')[0] || 'en'
      const candidates = Array.from(new Set([
        data.wiki_title,
        data.wiki_title.replace(/_/g, ' '),
        data.wiki_title.replace(/_Precinct$/i, ''),
        data.wiki_title.replace(/_Museum$/i, ''),
      ])).filter(Boolean)
      for (const t of candidates) {
        const urls = [
          `https://${langCode}.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(decodeURIComponent(t))}?redirect=true`,
          `https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(decodeURIComponent(t))}?redirect=true`,
        ]
        for (const url of urls) {
          const wiki = await fetch(url, { headers: { 'Accept-Language': lang } })
          if (wiki.ok) {
            const w = await wiki.json()
            data.summary = {
              extract: w.extract || '',
              thumbnail: w.thumbnail ? { source: w.thumbnail.source } : undefined,
              attribution: w.content_urls ? { url: w.content_urls.desktop?.page || '', source: 'Wikipedia', license: 'CC BY-SA' } : undefined,
              lang: w.lang || lang
            }
            break
          }
        }
        if (data.summary) break
      }
    } catch (_err) { void _err }
  }
  const thumb = data?.summary?.thumbnail?.source
  if (thumb) {
    data.summary.thumbnail.source = toProxyImageUrl(thumb)
  }
  return data
}

export async function buildCityPack(city: string, lang: string, token?: string) {
  const u = new URL(`${API_BASE}/api/packs/${city}/build`)
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  if (token) headers['Authorization'] = `Bearer ${token}`
  const r = await fetch(u.toString(), { method: 'POST', body: JSON.stringify({ lang }), headers })
  if (!r.ok) {
    let msg = 'request failed'
    try {
      const data = await r.json()
      msg = data?.error || msg
    } catch {
      msg = `${r.status}`
    }
    throw new Error(msg)
  }
  return await r.json()
}

export function toProxyImageUrl(original: string) {
  return original
}
